<template>
  <div class="counter-text">
    <div class="counter-text_number">
      <counter-increase :count_to="count_to_number"/>{{add_plus_symbol ? '+' : ''}}
    </div>
    <div class="counter-text_title">{{title}}</div>
  </div>
</template>

<script>
import CounterIncrease from "./CounterIncrease.vue";

export default {
  name: "CounterText",
  components: {CounterIncrease},
  props: {
    count_to: {
      type: [String, Number],
      default: 0
    },
    title: {
      type: String,
      default: ''
    },
    add_plus_symbol: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    count_to_number() {
      let number = Number(this.count_to)
      return isNaN(number)
        ? 0
        : number
    }
  }
}
</script>
